import http from '../services/http';
import { typeAs } from '../services/utils';
import Str from '../services/str';

export default {
  namespaced: true,

  state: {
    newsList: [],
    news: null,
    links: null,
    meta: null,
    filter: {
      tab: '',
      year: '',
      keyword: '',
      status: '',
    },
    newsTypeOptions: [
      { value: 'company', text: '公司' },
      { value: 'finance', text: '財務' },
      { value: 'xpg', text: 'XPG' },
      { value: 'consumer', text: '消費性電子' },
      { value: 'industrial', text: '工業解決方案' },
      { value: 'lighting', text: 'LED照明' },
      { value: 'powertrain', text: '動力' },
    ],
  },

  mutations: {
    CLEAR_ALL(state) {
      state.newsList = [];
      state.news = null;
    },
    SET_NEWSLIST(state, data) {
      state.newsList = data.data.map(
        (item) => {
          item.isChecked = false;
          return item;
        },
      );
      state.links = data.links;
      state.meta = data.meta;
    },
    SET_NEWS(state, data) {
      state.news = data;
    },
    SET_FILTER(state, data) {
      state.filter = data;
    },
    SET_META(state, data) {
      state.meta = data;
    },
  },

  actions: {
    clear({ commit }) {
      commit('CLEAR_ALL');
    },

    setFilter({ commit }, data) {
      commit('SET_FILTER', data);
    },

    setMeta({ commit }, data) {
      commit('SET_META', data);
    },

    setNews({ commit }, data) {
      commit('SET_NEWS', data);
    },

    find({ commit, state }) {
      let url = `/news?${Str.query(state.filter)}`;
      if (state.meta) {
        url += `&page=${state.meta.current_page}&page_count=${state.meta.per_page}`;
      }
      return http(url)
        .then((response) => {
          response.body.data.map(typeAs('News'));
          return response.body;
        })
        .then((response) => {
          commit('SET_NEWSLIST', response);
        });
    },

    findById({ commit }, id) {
      return http(`/news/${id}`)
        .then((response) => response.body)
        .then(typeAs('News'))
        .then((item) => {
          commit('SET_NEWS', item);
        });
    },

    destroy(_, id) {
      return http(`/news/${id}`, { method: 'DELETE' })
        .then((response) => response.body);
    },

    save(_, {
      id, ...data
    }) {
      const request = id
        ? http(`/news/${id}`, { method: 'PUT', data })
        : http('/news', { method: 'POST', data });

      return request.then((response) => response.body);
    },

    changeStatus(_, {
      id, ...data
    }) {
      const request = http(`/news/${id}/status`, { method: 'PUT', data });

      return request.then((response) => response.body);
    },

    changeIsTop(_, id) {
      const request = http(`/news/${id}/is_top`, { method: 'PUT' });

      return request.then((response) => response.body);
    },

    changeIsShowOnHomepge(_, id) {
      const request = http(`/news/${id}/show_on_homepage`, { method: 'PUT' });

      return request.then((response) => response.body);
    },
  },
};
